import React from 'react';
import _ from 'lodash';
import { Checkbox, FormControl, FormControlLabel, FormHelperText } from '@mui/material';
import { useDebouncedCallback } from 'use-debounce';

import { InfoField } from './InfoField';
import { handleShowOn, handleDynamicFunction } from '../../services/functions';
import { useDynamicFunction } from '../../services/hooks';

export const BoolField = props => {
  const { field, formik, getFieldCallback } = props;
  const dynamicFunction = useDynamicFunction(field.on_change);
  const debounced = useDebouncedCallback(
    val => {
      if (!_.isNil(dynamicFunction)) {
        const res = handleDynamicFunction(dynamicFunction, formik, field, val);
        if (res.callback) {
          props[res.callback](res.data, field.options.indexOf(val));
        }
      } else {
        formik.setFieldValue(field.name, val);
      }
    },
    300
  );

  if (!handleShowOn(field.show_on, formik.values, getFieldCallback(!_.isNil(field.show_on) ? field.show_on.trim().split(' ')[0].split('-')[0] : []))) {
    return null;
  }

  return (
    <FormControl style={{ paddingBottom: 15, display: field.hide ? 'none' : handleShowOn(
      field.show_on, formik.values,
      getFieldCallback(!_.isNil(field.show_on) ? field.show_on.trim().split(' ')[0].split('-')[0] : []))
      ? ''
      : 'none' }}
    fullWidth>
      <FormControlLabel
        control={
          <Checkbox
            name={field.name}
            checked={formik.values[field.name] || false}
            onChange={e => debounced(!formik.values[field.name])}
          />
        }
        label={<span dangerouslySetInnerHTML={{ __html: field.label }}></span>}
      />
      <FormHelperText sx={{ color: '#FF4842' }}>{formik.touched[field.name] && formik.errors[field.name]}</FormHelperText>
      {
        !_.isEmpty(field.infos)
          ? _.map(field.infos, (info, key) => <InfoField info={info} key={key} getFieldCallback={getFieldCallback} formikValues={formik.values} />)
          : null
      }
    </FormControl>
  );
};
